import data_cards from '../data/cards.json'

const Utils = {

	find_chains: function(data) {
		var chains = [];

		for (var i in data.board) {
			var current_slot = data.board[i]
			var chain = [];

			if (!_.includes(_.flatten(chains), current_slot)) {
				Utils.update_chain({ slot: current_slot, chain: chain, board: data.board })

				if (chain.length >= data.config.cards_in_chain) {
					chains.push(chain);
				}
			}
		}

		return chains;
	},


	update_chain: function(data) {
		data.chain.push(data.slot)
		if (data.slot.card && data.slot.card.value) {
			var adjacents = Utils.get_adjacents({ slot: data.slot, board: data.board })
			for (var direction in adjacents) {
				if (adjacents[direction] && adjacents[direction].card && adjacents[direction].card.value == data.slot.card.value) {
					
					if (!_.includes(data.chain, adjacents[direction])) {
						Utils.update_chain({ slot: adjacents[direction], chain: data.chain, board: data.board })
					}
				}
			}
		}
	},


	get_adjacents: function(data) {
		var adjacents = {
			top: false,
			right: false,
			bottom: false,
			left: false
		}

		var position = data.slot.position - 1;

		if (position % 4 !== 3 && data.board[position+1]) adjacents.right = data.board[position+1];
		if (position % 4 !== 0 && data.board[position-1]) adjacents.left = data.board[position-1];
		if (data.board[position-4]) adjacents.top = data.board[position-4];
		if (data.board[position+4]) adjacents.bottom = data.board[position+4];

		return adjacents
	},


	generate_card: function(filters) {
		return _.cloneDeep(_.sample(_.filter(data_cards, filters)));
	},


	get_type_by_rate: function(store) {
		var nb_spawn_rates = 0
		_.each(store.state.config.spawn_rates, function(s) {
			nb_spawn_rates += s
		})

		var type = false;
		var n = _.random(0, nb_spawn_rates-1);
		var s = 0;
		for (var spawn in store.state.config.spawn_rates) {
			s += store.state.config.spawn_rates[spawn]
			if (n < s) {
				type = spawn;
				break;
			}
		}
		if (!type) type = 'default';

		return type
	},


}

export default Utils 


// WEBPACK FOOTER //
// ./src/core/Utils.js